import header from './header-i18n-ru.json';

export const headerResource = { ...header };
